import { css } from 'styled-components'

export const mixinTitle = css`
  padding: 20px 0 0 20px;
  font-size: 28px;
  margin: 0;
  font-weight: 400;
`

export const mixinMainContainer = css`
  padding-top: 20px;
`

export const mixinInputForm = css`
  display: block;
  width: 100%;
  margin: 1rem auto;
  background-color: ${props => props.theme.clients.colors.white};
  border: 1px solid ${props => props.theme.clients.colors.silver._70};
  border-radius: 0;
  color: ${props => props.theme.clients.colors.black._100};
  font-size: .875rem;
  height: 2.875rem;
  padding: 0 1rem;

  &:focus {
    outline: 0;
    border-color: ${props => props.theme.clients.colors.lightGreen};
    box-shadow: none;
  }

  &::placeholder {
    color: ${props => props.theme.clients.colors.silver._70};
  }

  &:disabled {
    background-color: #dbdde3;
    color: #a8abb7;
    cursor: not-allowed;
  }
`
